import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "progress-bar" }

interface Props {
  progress?: number; // 0-100
  isUploading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProgressBar',
  props: {
    progress: { default: 0 },
    isUploading: { type: Boolean, default: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["progress-bar__line", {'progress-bar__line--complete': !__props.isUploading && __props.progress === 100}]),
      style: _normalizeStyle({ width: `${__props.progress}%` })
    }, null, 6)
  ]))
}
}

})